import { httpApi } from "./http.api";

export const authorizedUser = (): Promise<any> =>
  httpApi
    .post<any>("candidate/mail/authorize-user/", {})
    .then(({ data }) => data);

export const unauthorized = (): Promise<any> =>
  httpApi.post<any>("candidate/mail/unauthorize/", {}).then(({ data }) => data);
